export const PurchaseOrderKey = {
  poNumber: "poNumber",
  status: "statusId",
  effectiveDate: "effectiveDate",
  currentAmount: "currentAmount",
  expiryDate: "expiryDate",
};
